import ApiService from '@/services/apiService';
import { randomInt, downloadAttachment, userItemsPerListMixin } from '@/utils/vuex';
import { mapMutations, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import listMixin from '@/components/niotaClassic/listMixin';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewAccountMgmtAccountMgmtLogs',
  mixins: [listMixin, userItemsPerListMixin],
  data: function () {
    return {
      csvDownloadModal: false,
      csvDownloadModalText: null,
      csvDownloadModalStart: null,
      selected: [],
      expanded: [],
      actionButtons: [{
        icon: 'fal fa-download',
        title: this.$i18n_t('accMgmt.system.downloadAsCsv'),
        valid: true,
        tooltip: this.$i18n_t('accMgmt.system.downloadAsCsv'),
        action: 'runCSVExport'
      }],
      tableOptions: {
        ...defaultTableOptions
      },
      search: null,
      tableLoading: false,
      items: [],
      serverItemsLength: -1,
      priorTableOptions: {},
      data: {
        date: Date.now() - 86400000
      },
      selectedTime: null,
      loading: false,
      disableFetchOnCreatedMixin: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    ...mapGetters({
      userPrimaryScopeIds: 'authentication/primaryScopeIds',
      sessionUserId: 'authentication/userId'
    }),
    tableLocalizations() {
      return {
        headers: [{
          sortable: true,
          text: this.$i18n_t('Common.serverTime'),
          value: 'createdAt'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.tenant'),
          value: 'tenantName'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.logType'),
          value: 'type'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.action'),
          value: 'action'
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    search: debounce(function () {
      // make sure to start a new search with an offset of 0 === page 1
      this.tableOptions = {
        ...this.tableOptions,
        page: 1
      };
    }, 500)
  },
  mounted() {
    moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
    // TODO: pick the highest primary scope of the user?
    this.data.scopeIds = this.userPrimaryScopeIds;
    this.fetchList();
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    fetchList() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.tableLoading = true;
      const {
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = page ? page - 1 : 0;
      const usedItemsPerPage = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
      ApiService.fetchActivityLogs(this, {
        ...this.data,
        limit: usedItemsPerPage,
        offset: usedPage * usedItemsPerPage,
        orderAsc: sortDirection === 'ASC',
        search: this.search
      }).then(data => {
        this.items = data.logs;
        this.serverItemsLength = data.totalCount;
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.errorLoadingData'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
        this.tableLoading = false;
      });
    },
    dateTimeChange(dateObject) {
      this.data.date = dateObject.from * 1000;
      this.data.dateEnd = dateObject.to * 1000;
      this.fetchList();
    },
    date(date, time = false) {
      if (date) {
        // base date on backend UTC time to match actual CSV log export
        return time ? moment(new Date(date)).format('L LTS') : moment(new Date(date)).format('L');
      }
    },
    runCSVExport() {
      this.csvDownloadModal = true;
      const changeText = () => {
        const texts = this.$i18n_t('accMgmt.system.csvLoadingTexts');
        if (this.csvDownloadModalText === null) {
          this.csvDownloadModalText = `${texts[0]}\n`;
        } else if (this.csvDownloadModalText.endsWith('...')) {
          let newText = undefined;
          do {
            newText = texts[randomInt(texts.length - 1)];
          } while (this.csvDownloadModalText.startsWith(newText));
          this.csvDownloadModalText = `${newText}\n`;
        } else {
          this.csvDownloadModalText = `${this.csvDownloadModalText}.`;
        }
        this.csvDownloadModalStart = setTimeout(changeText, 1500);
      };
      changeText();
      ApiService.downloadActivityLogsCSVExport(this, this.data).then(data => {
        this.csvDownloadModal = false;
        clearTimeout(this.csvDownloadModalStart);
        this.csvDownloadModalText = null;
        const startDate = new Date(this.data.date);
        const endDate = new Date(this.data.dateEnd || new Date());
        const fileName = `n20_logs_${startDate.toISOString()}_${endDate.toISOString()}.csv`;
        downloadAttachment('text/csv', data, fileName);
      }).catch(error => {
        console.error(error);
      });
    }
  }
};